import { Controller } from "@hotwired/stimulus";

/**
 * Video Embed Controller
 * Handles GDPR-compliant YouTube embeds
 * Shows placeholder until user consents to embedded media cookies
 */
export default class extends Controller {
  static targets = ["placeholder", "embed"];

  connect() {
    // Check if user has already consented to embeds
    if (this.hasEmbedsConsent()) {
      this.showEmbed();
    } else {
      // Listen for consent events
      document.addEventListener("cookie:embeds-accepted", this.handleConsentGiven);
    }
  }

  disconnect() {
    document.removeEventListener("cookie:embeds-accepted", this.handleConsentGiven);
  }

  /**
   * Check if user has consented to embedded media
   */
  hasEmbedsConsent() {
    const cookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("cookie_preferences="));

    if (cookie) {
      try {
        const preferences = JSON.parse(decodeURIComponent(cookie.split("=")[1]));
        return preferences.embeds === true;
      } catch (e) {
        return false;
      }
    }

    return false;
  }

  /**
   * Handle consent given event
   */
  handleConsentGiven = () => {
    this.showEmbed();
  };

  /**
   * Show the embed and hide the placeholder
   */
  showEmbed() {
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("hidden");
    }

    if (this.hasEmbedTarget) {
      this.embedTarget.classList.remove("hidden");
    }
  }
}
